import { GetterTree } from "vuex";
import { UserData } from "@/models/UserData";
import { RootState } from "@/models/states/RootState";
import { MainState } from "@/models/states/MainState";
import HelperService from "@/services/HelperService";

const getters: GetterTree<MainState, RootState> = {
  userData(state): UserData {
    return state.userData;
  },

  hasPhonesSyncRole(state): boolean {
    if (state.userData) {
      return HelperService.isUserInRole(state.userData, "PhonesSync");
    }
    return false;
  },
};
export default getters;
